<script lang="ts" setup>
import type { InputHeading } from "@/types";

defineProps<{ blok: InputHeading }>();
</script>

<template>
  <div v-editable="blok" class="md:col-span-2">
    <h2 class="text-xl font-helvetica-bold">{{ blok.text }}</h2>
  </div>
</template>
